import { JetView } from "webix-jet"; // Importing JetView class from Webix Jet framework
import { devConfig } from "config/config"; // Importing application configuration file

/**
 * Class representing the TableWatchListReportView.
 * Handles both detailed and summarized Watch List report data in datatables.
 */
export default class TableWatchListReportView extends JetView { // Exporting a class that extends JetView to create a report table view
    config() { // Method defining the UI layout configuration
        const _ = this.app.getService("locale")._; // Getting localization service for translations

        return { // Returning the main UI structure
            rows: [ // Layout divided into vertical rows
                {
                    id: "preloader", // Container ID for the datatables
                    cols: [ // Child components arranged horizontally
                        {
                            view: "datatable", // Webix datatable component for detailed view
                            id: "datatable", // Unique ID for the detailed datatable
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for table borders
                            select: true, // Enables row selection
                            scrollY: true, // Enables vertical scrolling
                            columns: [ // Definition of columns for detailed data
                                {
                                    id: 'Action',
                                    header: '',
                                    width: 50,
                                    tooltip: 'Acción',
                                    hidden: !devConfig.getPermAction('InactiveAutomaticRule', 'Add'),

                                    template: function (obj) {
                                        // Template function for rendering the column

                                        if (obj.InactiveAutomaticRule != 'S')
                                            // Check if the register is not active
                                            return '';
                                        else

                                            return `
            <div title="Reactivar usuario" style="padding:0px 14px;display:inline-block;background:green;color:#fff;font-size:13px;"
                class="webix_table_checkbox webixbutton approbarbutton">
                A
            </div>
        `;
                                    },
                                },
                                {
                                    id: "ValidationId", // Column ID for validation identifier
                                    header: _("ID Validación"), // Localized column header
                                    width: 130, // Column width
                                    sort: "int" // Enables numeric sorting
                                },
                                {
                                    id: "UserId", // Column ID for user identifier
                                    header: _("ID Usuario"), // Localized column header
                                    width: 130, // Column width
                                    sort: "int" // Numeric sorting
                                },
                                {
                                    id: "ValidationDate", // Column ID for validation date
                                    header: _("Fecha Validación"), // Localized column header
                                    width: 200, // Column width
                                    sort: "string" // Sort by string value
                                },
                                {
                                    id: "Result", // Column ID for result
                                    header: _("Resultado"), // Localized column header
                                    width: 160 // Column width
                                },
                                {
                                    id: "List", // Column ID for list type
                                    header: _("Lista"), // Localized column header
                                    width: 200 // Column width
                                },
                                {
                                    id: "Score", // Column ID for score value
                                    header: _("Score"), // Localized column header
                                    width: 120 // Column width
                                },
                                {
                                    id: "UserName", // Column ID for username
                                    header: _("Nombre de Usuario"), // Localized column header
                                    width: 200 // Column width
                                },
                                {
                                    hidden: !devConfig.getPermAction('InactiveAutomaticRule', 'Add'),
                                    id: "InactiveAutomaticRule", // Column ID for InactiveAutomaticRule
                                    header: _("Inactivo por regla automática"), // Localized column header
                                    width: 200, // Column width
                                    template: function (obj) {
                                        return obj.InactiveAutomaticRule === "S" ? "Sí" : "No";
                                    }

                                },
                            ],
                            onClick: {
                                /**
                                 * Event handler for clicking the approve button.
                                 * @param {Object} ev - Event object.
                                 * @param {string} id - ID of the clicked item.
                                 */
                                approbarbutton: function (ev, id) { // Handles the approval action for a selected record.

                                    var item = this.getItem(id); // Retrieves the selected record by its ID.

                                    if (item.InactiveAutomaticRule == 'S') { // Validates that the record is eligible for activation.

                                        webix.confirm({
                                            title: _('Confirmación'),
                                            text: _('¿Está seguro de reactivar este usuario? Esta acción habilitará nuevamente el acceso a la plataforma.'),
                                            ok: _('Sí'),
                                            cancel: _('No'),
                                            callback: function (result) {
                                                if (!result) return; // Stops the process if the user cancels.

                                                webix.ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Sets the request content type.
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/UpdateUserSecurity', // Sends the activation request to the API.
                                                        JSON.stringify({
                                                            Action: 'State', // Specifies the action to update the record state.
                                                            Id: item.UserId, // User identifier.
                                                            logId: item.logId, // Log identifier.
                                                            IsActivate: 'A' // Marks the record as active.
                                                        }),
                                                        {
                                                            error: function () {
                                                                webix.message('Error!'); // Displays an error message if the request fails.
                                                            },
                                                            success: function () {
                                                                webix.message(_('Cambios Realizados')); // Displays a success message after activation.
                                                            }
                                                        }
                                                    );
                                            }
                                        });

                                    } else {

                                        webix.message({
                                            title: '¡Error!',
                                            type: 'alert-error',
                                            text: _('No puedes activar un registro ya actualizado.') // Notifies that the record has already been processed.
                                        });

                                    }

                                    return false; // Prevents the default event behavior.
                                },
                            },
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: "pagerA", // Links datatable to pager component
                            tooltip: true, // Enables tooltips on hover
                        },
                        {
                            view: "datatable", // Second datatable for summarized data
                            id: "datatable2", // Unique ID for summary table
                            css: "webix_header_border webix_data_border webix_footer_border", // Same border styling
                            hidden: true, // Initially hidden until summary view is selected
                            select: true, // Enables selection
                            scrollY: true, // Enables vertical scrolling
                            columns: [ // Columns for summarized data
                                {
                                    id: "Date", // Column ID for date
                                    header: _("Fecha"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "TotalValidations", // Column ID for total validations
                                    header: _("Total Validaciones"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "Coincidences", // Column ID for coincidences
                                    header: _("Coincidencias"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "NoCoincidences", // Column ID for no coincidences
                                    header: _("Sin Coincidencias"), // Localized header
                                    width: 200 // Column width
                                },
                            ],
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: "pagerB", // Links table to the same pager
                            tooltip: true, // Enables tooltips
                        },
                    ],
                },
            ],
        };
    }

    init(grid) { // Method executed after component initialization
        const urlDetails = devConfig.geturlApi() + "UserManagement/WatchListReportDetails"; // API endpoint for detailed report data
        const urlSummary = devConfig.geturlApi() + "UserManagement/WatchListReport"; // API endpoint for summarized report data
        const vthis = this; // Reference to current class instance

        grid = $$("datatable");
        const grid2 = $$("datatable2");
        let filter = "";

        // Event listener before editing starts
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get column options
                if (item.InactiveAutomaticRule != 'I') {
                    // Check if the register is not inactive
                    console.log(item);
                    return false; // Prevent editing
                }
                console.log(id);
            }
        });
        // Event listener for when filter data is submitted
        this.on(this.app, "requests:filter", (filterData) => {
            let query = ""; // String to build query parameters

            // Add date filters to query if provided
            if (filterData.validationDateFrom && filterData.validationDateTo) {
                query += `&validationDateFrom=${filterData.validationDateFrom}`; // Start date
                query += `&validationDateTo=${filterData.validationDateTo}`; // End date
            }

            // Add other filters dynamically if they exist
            if (filterData.result) query += `&result=${filterData.result}`; // Result filter
            if (filterData.documentNumber) query += `&documentNumber=${filterData.documentNumber}`; // Document number filter
            if (filterData.userId) query += `&userId=${filterData.userId}`; // User ID filter
            if (filterData.InactiveAutomaticRule) query += `&InactiveAutomaticRule=${filterData.InactiveAutomaticRule}`; // Automatic rule status filter


            // Determine which datatable to display based on selected view type
            if (filterData.Overall == 1) { // If summarized view selected
                grid.hide(); // Hide detailed datatable
                grid2.show(); // Show summarized datatable
                grid2.clearAll(); // Clear previous data
                grid2.load(`${urlSummary}?start=0&count=${grid2.data.$pagesize}${query}`); // Load new data from API
            } else { // If detailed view selected
                grid2.hide(); // Hide summarized datatable
                grid.show(); // Show detailed datatable
                grid.clearAll(); // Clear existing data
                grid.load(`${urlDetails}?start=0&count=${grid.data.$pagesize}${query}`); // Load detailed data from API
            }
        });
    }
}
